/*eslint-disable*/
import React from "react";
export default function Footer() {
  return (
    <p className="text-center text-sm text-gray-600 md:text-base lg:mb-0">
      ©{1900 + new Date().getYear()} Atrium. All Rights Reserved.
    </p>
  );
}
